<template>
    <div class="a-company-info company-info">
        <span class="company-info__label">
            {{ $t('o-company-info_label') }}
        </span>
        <img 
            src="../../../assets/images/mvg-logo.png" 
            :alt="`${$t('company-info_logo')}`"
            class="company-info__logo"
        >
    </div>
</template>

<script>
export default {
    name: 'ACompanyInfo'
    
}
</script>

<style lang="scss">
@import "a-company-info";
</style>
